import React from "react";
import { connect } from "react-redux";
import EventLabel from "../../../../core/EventLabel/EventLabel";
import { formActions } from "../../../../store/actions/cms/form/form.action";
import { sourceTypes } from "../../../../constants/cms/sourceType";
import { templateActions } from "../../../../store/actions/cms/template/template.action";
import { pageActions } from "../../../../store/actions/cms/page/page.action";
import { deepClone } from "../../../../helpers/objectHelper";
import { conditionActions } from "../../../../store/actions/cms/condition.action";

class Content extends React.Component {
  handleUpdate = element => {
    const { dispatch, cms, page } = this.props;

    if (cms.enviroment === sourceTypes.TEMPLATE) {
      const template = deepClone(this.props.template);
      //Move this code to reducer
      if (element.parentName === "HEADER") {
        let el = template.content.header.content.find(f => {
          return f.contentId === element.contentId;
        });
        var indexOfRemovedEl = template.content.header.content.indexOf(el);
        if (indexOfRemovedEl > -1) {
          template.content.header.content.splice(indexOfRemovedEl, 1);
          template.content.header.content.push(element);
        }
      }
      if (element.parentName === "FOOTER") {
        let el = template.content.footer.content.find(f => {
          return f.contentId === element.contentId;
        });
        var indexOfRemovedEl = template.content.footer.content.indexOf(el);
        if (indexOfRemovedEl > -1) {
          template.content.footer.content.splice(indexOfRemovedEl, 1);
          template.content.footer.content.push(element);
        }
      }
      dispatch(templateActions.softUpdate(template));
    } else if (cms.enviroment === sourceTypes.PAGE) {
      dispatch(pageActions.updatePageElement(element, null, page));
    } else if (cms.enviroment === sourceTypes.FORM) {
      dispatch(formActions.updateFormElement(element));
      dispatch(conditionActions.triggerCheck(element.formElementId));
    }
  };
  handleChange = (value, path, contentId = null) => {
    let elementCopy = deepClone(this.props.element);
    const names = path.split(".");
    if (names.length === 2) elementCopy[names[0]][names[1]] = value;
    else if (names.length === 3)
      elementCopy[names[0]][names[1]][names[2]] = value;
    this.handleUpdate(elementCopy);
  };
  render() {
    const { element } = this.props;
    if (
      element === undefined ||
      (element && element.data && element.data.hidden)
    )
      return null;
    return (
      <div
        style={{
          padding: element.data.padding ? element.data.padding.toString().includes("px")
            ? element.data.padding
            : element.data.padding + "px" : 'initial',
          margin: element.data.margin ? element.data.margin : 'initial',
          backgroundColor: element.data.backgroundColor,
          width: "100%"
        }}
        className={
          element.parentName !== undefined && element.props.type !== "MAP"
            ? "responsive-col resposive-hf-col"
            : ""
        }
      >
        <EventLabel
          type={element.props.type}
          value={element.props.value}
          settings={element.data}
          onChange={this.handleChange}
          contentId={element.contentId}
          data={element.data}
          isColumnChild={element.parentId !== null}
          onSelect={this.onSelect}
          element={element}
          isHeaderText={
            element.parentName !== undefined && element.props.type === "TEXT"
              ? true
              : false
          }
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedElement: state.form.selectedElement,
    form: state.form,
    page: state.page,
    template: state.template.template,
    cms: state.cms
  };
}

export default connect(mapStateToProps)(Content);
